import React from 'react'
import "./Social.css"
const Social = () => {
  return (
    <div>
           <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }} className="project-heading">
              Social<strong>Feed</strong>
              </h1>
        <div className="gallery">
        <img src="https://user-images.githubusercontent.com/77965216/186582010-ea0257df-74b0-4eb0-a996-d2bb8fc4ff0b.png"/>
        <img src="https://user-images.githubusercontent.com/77965216/186582340-389286b1-38e1-45dc-b105-744e56050d25.png" />
        <img src="https://user-images.githubusercontent.com/77965216/186582540-3e1292d8-30dd-4841-8364-1be652227fd9.png" />
        <img src="https://user-images.githubusercontent.com/77965216/186582746-1a729d46-0e2b-449a-a41d-090b7426651d.png" />
        <img src="https://user-images.githubusercontent.com/77965216/186583093-1c5a436c-6da7-4938-b953-579856a7e3ec.png" />
        <img src="https://user-images.githubusercontent.com/77965216/186583334-29c9750d-c79c-4c62-bc4d-0567cc94b057.png" />
      </div>

    </div>
  )
}

export default Social